export default __webpack_public_path__ + "static/media/calendar.29d3c67e.png";